<div class="col-12" *ngIf="!isLoading">
    <div class="flex flex-row-reverse flex-wrap mb-3">
      <app-button label="All files" iconPos="right" [outlined]="true" severity="secondary"
        [icon]="isAllFilesDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
        (onClickEvent)="onDownloadClick()"></app-button>
    </div>
    <app-grid #grid [domLayout]="'normal'" [rowData]="rowData" [rowHeight]="40" rowSelection="single"
      (selectionChangedEvent)="onSelectionChanged($event)" [columnDefs]="columnDefs" [pagination]="true"
      (refreshEvent)="getData()">
    </app-grid>
</div>

<app-loading class="mt-2 flex align-items-center justify-content-center" *ngIf="isLoading"></app-loading>